





































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Images from '../Images.vue'
import { Designer, generateEmptyDesigner } from '../../types/designers'
import { DocumentData } from '../../types/images'
import { uploadDocument } from '../../utils/http-client/documents-api'
import { postDesigner, editDesigner } from '../../utils/http-client/designer-api'
import MessageBus from '../../utils/buses/MessageBus'
import { requiredValidation } from '@/utils/validations'

@Component({
  components: {
    Images
  }
})
export default class DesignerForm extends Vue {
  @Prop({ default: generateEmptyDesigner })
  designer!: Designer

  @Prop({ default: false })
  isEditing!: Boolean

  private image: Blob | null = null
  private imagesPreview: string[] = []
  private documents: Blob[] = []
  private documentsPreview: string[] = []
  private valid: boolean = true
  private isSubmitting: boolean = false
  private rules: Object = {
    required: requiredValidation
  }

  previewImage () {
    this.imagesPreview = []
    if (this.image) {
      const reader = new FileReader()
      reader.onload = () => {
        this.imagesPreview.push(reader.result as string)
      }
      reader.readAsDataURL(this.image)
    }
  }
  async uploadImage () {
    const imageUrl = await uploadDocument(this.image as any, 1, true, 'image')
    if (imageUrl) {
      this.$set(this.designer, 'imageurls', [imageUrl])
    }
  }
  private async onSubmit () {
    this.isSubmitting = true
    try {
      if (this.imagesPreview.length) {
        await this.uploadImage()
      }
      if (this.isEditing) {
        await editDesigner(this.designer)
      } else {
        await postDesigner(this.designer)
      }
    } catch (err) {
      console.error('Designer Sign Up Error', err)
      MessageBus.sendDefaultError()
    } finally {
      this.isSubmitting = false
      this.$emit('close-dialog')
    }
  }
}
